import React from 'react';
import Alert from '../../../common/helpers/alert';

function VoipAlert({
  error,
  clearError
}) {
  if (!error) {
    return null;
  }
  return (
    <Alert
      errorString={ error }
      onClose={ clearError }
    />
  );
}

export default VoipAlert;
